import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

export const useMultiPackageShipments = () => {
  const isFeatureEnabled = useFeatureFlag(FeatureFlagDeclarations.enableMultiPackageShipments);
  return isFeatureEnabled;
};
